import React from 'react';
import { AnimatedText } from './AnimatedText';
import { CallBannerInfoProps } from './index.types';

/**
 * CallBannerInfo displays the caller information section of the call banner.
 *
 * Shows:
 * - Call type label (e.g., "Incoming call" or "Video call invite from")
 * - Caller name/location/phone number
 * - Ring group name (if applicable), as "via {ringGroupName}"
 * - Phone number (for voice calls when name is present)
 *
 * @remarks
 * The caller label is truncated with ellipsis if too long, with full text shown on hover.
 */
export const CallBannerInfo = ({
  callTypeLabel,
  callerLabel,
  ringGroupName,
  showPhoneNumber,
  formattedPhoneNumber,
}: CallBannerInfoProps) => {

  return (
    <div className="flex-1 space-y-[4px] max-w-[200px]">
      <div className="text-[14px] font-normal text-foreground leading-[19px]">
        {callTypeLabel}
      </div>

      <AnimatedText
        text={callerLabel}
        className="text-[16px] font-bold text-foreground select-text leading-[22px]"
        maxWidth={200}
      />

      {ringGroupName && (
        <div className="text-[16px] text-foreground select-text">
          via <span className="font-bold">{ringGroupName}</span>
        </div>
      )}

      {showPhoneNumber && (
        <div className="text-[14px] font-normal text-foreground leading-[19px]">
          {formattedPhoneNumber}
        </div>
      )}
    </div>
  );
};
